import '../social_content_context_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.DisqusContentContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = [
      Monitoring.Views.DisqusContentPreviousCommentsView,
      Monitoring.Views.DisqusContentFollowingCommentsView
    ]
    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()
